import { render, staticRenderFns } from "./DFe.vue?vue&type=template&id=f8bf3612&scoped=true&"
import script from "./DFe.vue?vue&type=script&lang=js&"
export * from "./DFe.vue?vue&type=script&lang=js&"
import style0 from "./DFe.vue?vue&type=style&index=0&id=f8bf3612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bf3612",
  null
  
)

export default component.exports